module.exports = "<ngx-loading-bar height=\"5px\"></ngx-loading-bar>\r\n<router-outlet></router-outlet>\r\n"